import { useSetAtom } from "jotai";
import { useCallback } from "react";
import { draftReturnAtomFamily } from "../atoms/draft-return.atom";
import { updateLineItem } from "../lib/draft.lib";
import type { DraftLineItem } from "../types";

export function useUpdateLineItem(orderId: string) {
  const setDraft = useSetAtom(draftReturnAtomFamily(orderId));

  // Must be stable: consumers list it in effect dependency arrays. An unstable
  // identity + a setter that always yields a new draft reference causes an
  // infinite render loop (React #185) — see use-line-item-resolution-form.
  return useCallback(
    (lineItemId: string, patch: Partial<DraftLineItem>) => {
      setDraft((draft) =>
        draft ? updateLineItem(draft, lineItemId, patch) : draft,
      );
    },
    [setDraft],
  );
}
